// import { FC, useContext, useEffect, useState } from "react";
// import { IProjectHistoryDisplay } from "../../../models/ProjectModels/ProjectModels";
// import HistoryTable from "../../Shared/HistoryTable/HistoryTable";
// import { Context } from "../../..";
// import { ITaskHistoryFilter } from "../../../models/TaskModels";
// import { useParams } from "react-router-dom";
// import "./TaskHistory.css";
// import { FilterOptionsExtented, SelectedOptions } from "../../../models/FilterModels/IFilterModel";
// import FilterContainer from "../../Shared/Filter/FilterContainer";
// import axios from "axios";
// import { AppContext } from "../../../App";

// interface TaskHistoryProps {
//     projectId: number;
//     records: IProjectHistoryDisplay[];
//     onChangeFilters: (filters: ITaskHistoryFilter) => void;
// }

// const TaskHistory: FC<TaskHistoryProps> = ({ records, onChangeFilters, projectId }) => {
//     const { id } = useParams();
//     const { store } = useContext(Context);
//     const { showToast } = useContext(AppContext);
//     const [filterCounter, setFilterCounter] = useState<number>(0);
//     const [historyFilter, setHistoryFilter] = useState<FilterOptionsExtented>();
//     const [selectedFilter, setSelectedFilter] = useState<SelectedOptions>({});

//     useEffect(() => {
//         (async () => {
//             // if (!store.currentProjectId) return;

//             try {
//                 const response = await store.filterService.getFilters({
//                     projectId: projectId,
//                     projectUser: true,
//                 });
//                 const data = response.data;

//                 const options: FilterOptionsExtented = {
//                     date: true,
//                     historyAuthor: data.projectUsers
//                 }

//                 setHistoryFilter(options);
//             } catch (error: any) {
//                 if (axios.isAxiosError(error)) {
//                      showToast(error.response?.data?.message, error.response?.data?.details);
//                 }
//             }
//         })();
//     }, [store.currentProjectId]);

//     useEffect(() => {
//         (async () => {
//             if (Object.keys(selectedFilter).length === 0) parseFilters();
//         })();
//     }, [selectedFilter]);

//     const onCancelClick = async () => {
//         setSelectedFilter({});
//     };

//     const applyFilters = async () => {
//         parseFilters();
//     };

//     const parseFilters = async () => {
//         const filters: ITaskHistoryFilter = {
//             taskId: Number(id),
//             dateFrom: (selectedFilter.dates && selectedFilter.dates[0])?.toISOString(),
//             dateTo: (selectedFilter.dates && selectedFilter.dates[1])?.toISOString(),
//             userIds: selectedFilter.historyAuthorIds,
//         };
//         onChangeFilters(filters);
//     };

//     return (
//         <div>
//             <div className="task-history-filters">
//                 <FilterContainer
//                     filterCounter={filterCounter}
//                     setFilterCounter={setFilterCounter}
//                     selectedOptions={selectedFilter}
//                     setSelectedOptions={setSelectedFilter}
//                     filterOptions={historyFilter}
//                     onReset={onCancelClick}
//                     showApplyButton
//                     onApply={applyFilters}
//                 />
//             </div>
//             <HistoryTable records={records} onScrolledToBottom={() => {}} showHyperlinkColumn={false} />
//         </div>
//     );
// };

// export default TaskHistory;


import { FC, useCallback, useContext, useEffect, useMemo, useState } from "react";
import HistoryTable from "../../Shared/HistoryTable/HistoryTable";
import { Context } from "../../..";
import { useParams } from "react-router-dom";
import "./TaskHistory.css";
import { FilterOptionsExtented, SelectedOptions } from "../../../models/FilterModels/IFilterModel";
import FilterContainer from "../../Shared/Filter/FilterContainer";
import axios from "axios";
import { AppContext } from "../../../App";
import { handleError } from "../../../helpers/ErrorLib/handleError";
import { IProjectHistoryDisplay } from "../../../common/api_interfaces/history/IProjectHistoryDisplay";
import { ITaskHistoryFilter } from "../../../common/api_interfaces/history/ITaskHistoryFilter";

interface TaskHistoryProps {
    projectId: number;
    records: IProjectHistoryDisplay[];
    onChangeFilters: (filters: ITaskHistoryFilter) => void;
}

const TaskHistory: FC<TaskHistoryProps> = ({ records, onChangeFilters, projectId }) => {
    const { id } = useParams();
    const { store } = useContext(Context);
    const { showToast, handleShowLoader } = useContext(AppContext);
    const [filterCounter, setFilterCounter] = useState<number>(0);
    const [historyFilter, setHistoryFilter] = useState<FilterOptionsExtented>();
    const [selectedFilter, setSelectedFilter] = useState<SelectedOptions>({});

    // Мемоизированные значения
    const taskId = useMemo(() => Number(id), [id]);
    
    // Загрузка фильтров
    useEffect(() => {
        const loadFilters = async () => {
            if (!projectId) return;
        
            try {
                // handleShowLoader(true);
                const response = await store.filterService.getFilters({
                    projectId,
                    projectUser: true,
                });

                setHistoryFilter({
                    date: true,
                    historyAuthor: response.data.projectUsers
                });
            } catch (error: any) {
                handleError(error, {
                    defaultMessage: "Неизвестная ошибка при загрузке фильтров",
                    showToast: showToast
                });
            } finally {
                // handleShowLoader(false);
            }
        };

        loadFilters();
    }, [projectId, store.filterService, showToast]);

    // Парсинг фильтров с useCallback
    const parseFilters = useCallback(() => {
        const users = Array.isArray(selectedFilter.historyAuthorIds) && selectedFilter.historyAuthorIds.length > 0 ? selectedFilter.historyAuthorIds : undefined;
        const filters: ITaskHistoryFilter = {
            taskId,
            dateFrom: selectedFilter.dates && selectedFilter.dates?.[0]?.toISOString(),
            dateTo: selectedFilter.dates && selectedFilter.dates?.[1]?.toISOString(),
            userIds: users,
        };
        onChangeFilters(filters);
    }, [taskId, selectedFilter, onChangeFilters]);

    const handleCancelClick = useCallback(() => {
        const clearFilter: ITaskHistoryFilter = {taskId: taskId};
        onChangeFilters(clearFilter);
        setSelectedFilter(clearFilter as SelectedOptions);
    }, [parseFilters]);

    const handleApplyFilters = useCallback(() => {
        parseFilters();
    }, [parseFilters]);

    // Мемоизированный JSX для фильтров
    const filterSection = useMemo(() => (
        <div className="task-history-filters">
            <FilterContainer
                filterCounter={filterCounter}
                setFilterCounter={setFilterCounter}
                selectedOptions={selectedFilter}
                setSelectedOptions={setSelectedFilter}
                filterOptions={historyFilter}
                onReset={handleCancelClick}
                showApplyButton
                onApply={handleApplyFilters}
            />
        </div>
    ), [filterCounter, selectedFilter, historyFilter, handleCancelClick, handleApplyFilters]);

    return (
        <div>
            {filterSection}
            <HistoryTable 
                records={records} 
                onScrolledToBottom={() => {}} 
                showHyperlinkColumn={false} 
            />
        </div>
    );
};

export default TaskHistory;